import React, { useState, useEffect } from 'react';
import { useParams} from 'react-router-dom';
import axios from "axios";

export const EditBlog = (props)=>{
    const { id } = useParams();
    const [title, setTitle] = useState('');
    const [slug, setSlug] = useState('');
    const [content, setContent] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [myData, setMyData] = useState('');
    const [loading, setLoading] = useState(false);
    var option = {
      method: 'GET',
      url: `https://karlson.herokuapp.com/api/post/${id}`
    };
    useEffect(async()=>{
      await setLoading(true);
      axios
      .request(option)
      .then(async function(response) {
        let data = await JSON.stringify(response.data.data)
        await setMyData(JSON.parse(data))
        await setTitle(JSON.parse(data)[0].title)
        await setContent(JSON.parse(data)[0].content)
        await setSlug(JSON.parse(data)[0].slug)
      })
      .catch((err) => {
          console.log(err);
        })
      .finally(async() => {
        setLoading(false);
      });
    }, [])

    if (loading) return <div className="loader"><span className="load"></span><span className="load"></span><span className="load"></span></div>;
    
    async function editPost(){
        const title = document.getElementById("floatingName").value
        const slug = document.getElementById("floatingSlug").value
        const content = document.getElementById("floatingContent").value
        var option = {
          method: 'PATCH',
          url: `https://karlson.herokuapp.com/api/post/${await myData[0].sno}`,
          headers: {
            "Content-type": "application/json; charset=UTF-8"
            },
          data: JSON.stringify({
            "userid": email,
            "pass": password,
            "title": title,
            "slug": slug, 
            "content": content
            })

        };
        axios
          .request(option)
          .then(function(response) {
            alert(response.data.message)
          })
          .catch(function(err) {
            alert(err)
          });
      }

    return (
        <div className = "container">
        <h1 className="my-3 text-center">Edit Post</h1>
        {/**/}
        <div className="form-floating mb-3">
        <input type="emailid" value = {email} onChange = {(e)=>{setEmail(e.target.value)}} name = "emailid" className="form-control" id="floatingEmail" placeholder="EmailID"/>
        <label htmlFor="floatingName">Email</label>
        </div>
        {/**/}
        <div className="form-floating mb-3">
        <input type="password" value={password} onChange = {(e)=>{setPassword(e.target.value)}} name = "password" className="form-control" id="floatingPass" placeholder="Password"/>
        <label htmlFor="floatingSlug">Password</label>
        </div>
        {/**/}
        <div className="form-floating mb-3">
        <input type="text" value = {title} onChange = {(e)=>{setTitle(e.target.value)}} name = "title" className="form-control" id="floatingName" placeholder="Name"/>
        <label htmlFor="floatingName">Title</label>
        </div>
        {/**/}
        <div className="form-floating mb-3">
        <input type="text" value={slug} onChange = {(e)=>{setSlug(e.target.value)}} name = "slug" className="form-control" id="floatingSlug" placeholder="Slug"/>
        <label htmlFor="floatingSlug">Slug</label>
        </div>
        {/**/}
        <div className="form-floating mb-3">
        <textarea type="text" value={content} onChange = {(e)=>{setContent(e.target.value)}} name = "content" style={{height: "200px"}} className="form-control" id="floatingContent" placeholder="Content"></textarea>
        <label htmlFor="floatingContent">Content</label>
        </div>
        <button className="float-left sbtn atom-btn green-btn" onClick={editPost}>Post</button>
        </div>
)}